import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class formatoPdfService {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/formato`)
            .then(response => {
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

 

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/formato/${id}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

 
    /******* TRANSACCIONES ******/


    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/formato`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


}

export default new formatoPdfService();